const DEFAULT_USER_PERMISSIONS = { delete: [], view: [], update: [], create: [] };

const USER_PERMISSIONS = {
  CREATE: {
    CAMPAIGNS: "campaigns",
    INVITE_MEMBERS: "invite_members",
    APPLICANT_HUB: "applicant_hub"
  },
  DELETE: {
    DRAFT: "draft"
  },
  UPDATE: {
    MANAGE_MEMBERS: "manage_members",
    APPLICANT_HUB_SETTINGS: "applicant_hub_settings",
    INTEGRATIONS: "integrations",
    BUSINESS_SETTINGS: "business_settings",
    BILLING_ADDRESS: "billing_address",
    CAMPAIGNS_SETTINGS: "campaigns_settings"
  },
  VIEW: {
    CAMPAIGNS: "campaign_stats",
    DASHBOARD: "dashboard",
    INVOICES: "invoices",
    BUDGET: "budget",
    STATISTICS_HUB: "hub_stats"
  }
};

const ACTION_MESSAGES = {
  VIEW: {
    CAMPAIGNS: {
      TYPE: "view_campaign",
      SUCCESS_ACTION: "User accessed to the campaigns page",
      FAIL_ACTION:
        "User failed to access to the campaigns page, it doesn't have the required permissions"
    },
    DASHBOARD: {
      TYPE: "view_dashboard",
      SUCCESS_ACTION: "User accessed to the dashboard page",
      FAIL_ACTION:
        "User failed to access to the dashboard page, it doesn't have the required permissions"
    }
  },
  CREATE: {
    CAMPAIGNS: {
      TYPE: "create_campaign",
      SUCCESS_ACTION: "User started the booking process",
      FAIL_ACTION: "User failed to access the booking page, doesn't have the required permissions"
    }
  }
};

module.exports = { USER_PERMISSIONS, ACTION_MESSAGES, DEFAULT_USER_PERMISSIONS };
